import { h } from 'preact';
import * as actions from 'store/actions';
import { accessNested } from 'utils/utils';

function staticRender() {}
let storeListeners = {};

let linkGarden = typeof window !== 'undefined' && accessNested(window, '__INITIAL_STATE__.appData.pages.linkGarden');

function setupAdobePixel() {
	if (window.DIL || !linkGarden) {
		return;
	}

	const mediaRoot = Store.get().appData.urls.roots.studio;
	const filename  = 'dil_6_8_uphe_1.js';
	const filepath  = `${mediaRoot}/scripts/${filename}`;
	const library   = document.createElement('script');
	library.src     = filepath;

	// set up the adobe tracker thing once the library has loaded
	library.onload = () => {
		window.upheDil = window.DIL.create({
			partner: 'uphe',
			uuidCookie: {
				name: 'aam_uuid',
				days: 30
			},
			visitorService: { namespace: 'E9E0DFD558345FBC0A495C34@AdobeOrg' }
		});

		hookUpGA();
	};

	// add the adobe library to the page
	document.body.appendChild(library);
}

let hookupGAStart;
function hookUpGA() {
	if (typeof window.ga !== 'undefined') {
		ga(() => window.DIL.modules.GA.submitUniversalAnalytics(ga, window.upheDil));
	} else {
		let now = Date.now();
		if (!hookupGAStart) {
			hookupGAStart = now;
		}
		if (now - hookupGAStart < 10000) {
			setTimeout(hookUpGA, 50);
		}
	}
}

storeListeners[actions.PAGE_STATE_LOADED] = setupAdobePixel;
storeListeners[actions.SET_ACTIVE_PAGE] = setupAdobePixel;
storeListeners['TRACK_HOMEENT_BANNER_CLICK'] = () => adobeTrack({ name: 'Banner', trackingPrefix: 'MA' });

const linkGardenVendors = accessNested(linkGarden, 'data.links.vendors');
if (linkGardenVendors) {
	// GET THE NAMES OF EVERY RETAILER / SERVICE
	let retailers = [].concat(...Object.values(linkGardenVendors).map(format => format && format.list && Object.values(format.list)));

	// add a listener for every retailer click event
	// let retailer, urlSafeRetailer, trackId;
	retailers.forEach(retailer => {
		if (!retailer) {
			return;
		}
		let urlSafeRetailer = retailer.name.replace(/ +/g, '_');
		let prefix = retailer.trackingPrefix || 'HOMEENT';
		let trackId = retailer.customAdobeTrackId || `TRACK_${prefix}_${urlSafeRetailer}`.toUpperCase();
		storeListeners[trackId] = () => adobeTrack({
			name: retailer.name,
			trackingPrefix: retailer.trackingPrefix
		});
	});
}

function adobeTrack(retailer) {
	window.upheDil.api.signals({ c_event: `${retailer.trackingPrefix} ${retailer.name}` });
	window.upheDil.api.signals().submit();
}


export const disabledLevels = {
	// base: true,
	// studio: true,
};

export {
	staticRender,
	storeListeners
};
